import React, { useEffect, useRef, useState } from 'react';

const FormInput = ({
  type = "text",
  label,
  subtitle,
  helperText,
  name,
  onChange,
  placeholder,
  rows,
  options = {},
  maxLength = 50,
  mandatory = false,
  style = "",
  valueOverride,
  readOnly = false,
  disabled = false,
  autoComplete,
  id,
}) => {
  const textareaRef = useRef(null);
  const effectiveValue = valueOverride !== undefined ? valueOverride : (options?.[name] ?? '');
  const [charCount, setCharCount] = useState(effectiveValue.length);
  const showCharCount = charCount >= maxLength * 0.8;

  const handleChange = (e) => {
    const value = e.target.value;
    setCharCount(value.length);
    onChange(e);
  };

  useEffect(() => {
    const textarea = textareaRef.current;
    if (textarea) {
      textarea.style.height = 'auto';
      textarea.style.height = `${textarea.scrollHeight}px`;
    }
  }, [options?.[name], valueOverride]);

  useEffect(() => {
    setCharCount(effectiveValue.length);
  }, [effectiveValue]);

  return (
    <div className={`${style}`} style={{ fontFamily: '"Inter", sans-serif' }}>
      <div className={`flex items-center gap-3 mb-2 ${showCharCount ? 'justify-between' : ''}`}>
        <label htmlFor={name} className="block text-xs font-semibold tracking-tight gch-text-primary flex items-center gap-1.5">
          {label}
          {mandatory && (
            <span className="text-rose-500" aria-hidden>*</span>
          )}
        </label>
        {showCharCount && (
          <span className={`text-xs font-semibold tabular-nums shrink-0 ${
            charCount >= maxLength * 0.9 ? 'text-amber-600' : 'gch-text-muted'
          }`}>
            {charCount}/{maxLength}
          </span>
        )}
      </div>
      {subtitle && (
        <p className="text-xs gch-text-secondary mb-2.5 leading-relaxed">
          {subtitle}
        </p>
      )}
      <div className="relative">
        {type === "textarea" ? (
          <textarea
            id={id || name}
            name={name}
            rows={rows || 1}
            maxLength={maxLength}
            value={effectiveValue}
            onChange={handleChange}
            required={mandatory}
            readOnly={readOnly}
            disabled={disabled}
            autoComplete={autoComplete}
            className={`block w-full rounded-lg text-sm transition-all duration-200 py-2.5 px-3.5 gch-input-ghost border border-[var(--admin-border)] gch-text-primary placeholder:gch-text-muted focus:border-[var(--admin-accent)] focus:ring-2 focus:ring-[var(--admin-accent)]/15 focus:outline-none resize-none overflow-y-hidden ${readOnly ? 'cursor-default gch-text-secondary' : ''} ${disabled ? 'cursor-not-allowed opacity-60' : ''}`}
            placeholder={placeholder}
            ref={textareaRef}
          />
        ) : (
          <input
            type={type}
            id={id || name}
            name={name}
            value={effectiveValue}
            maxLength={maxLength}
            onChange={handleChange}
            required={mandatory}
            readOnly={readOnly}
            disabled={disabled}
            autoComplete={autoComplete}
            className={`block w-full rounded-lg text-sm transition-all duration-200 py-2.5 px-3.5 gch-input-ghost border border-[var(--admin-border)] gch-text-primary placeholder:gch-text-muted focus:border-[var(--admin-accent)] focus:ring-2 focus:ring-[var(--admin-accent)]/15 focus:outline-none ${readOnly ? 'cursor-default gch-text-secondary' : ''} ${disabled ? 'cursor-not-allowed opacity-60' : ''}`}
            placeholder={placeholder}
          />
        )}
      </div>
      {helperText && (
        <p className="text-xs gch-text-secondary mt-2 leading-relaxed">
          {helperText}
        </p>
      )}
    </div>
  );
};

export default FormInput;
